import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  inject,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { NgClass, NgIf } from '@angular/common';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';

@Component({
  selector: 'ciwc-order-view-attachments',
  templateUrl: './order-view-attachments.component.html',
  styleUrl: './order-view-attachments.component.scss',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    NgClass,
    MatTable,
    MatButton,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    NgIf,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderViewAttachmentsComponent {
  attachments: any[] = [];
  deleted = false;
  displayedColumns = ['name', 'url', 'status', 'actions'];

  private dialogRef = inject(MatDialogRef<OrderViewAttachmentsComponent>);
  private readonly cdr = inject(ChangeDetectorRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: { attachments: any[] }) {
    this.attachments = data.attachments.map((a) => ({ ...a }));
  }

  getStatus(attachment: any) {
    return attachment.id ? 'Saved' : 'Not saved yet';
  }

  isNotSaved(attachment: any) {
    return !attachment.id;
  }

  deleteAttachment(index: number) {
    this.attachments.splice(index, 1);
    this.attachments = [...this.attachments];
    this.deleted = true;
    this.cdr.markForCheck();
  }

  close() {
    this.dialogRef.close(this.deleted ? { attachments: this.attachments } : null);
  }

  trackByIndex(index: number) {
    return index;
  }
}
